import { useIntl } from "react-intl";
import PriceGapStatusEnum from "@models/PriceGapStatusEnum";
import WhatsThis from "../../../shared/WhatsThis/WhatsThis";
import { getStatusClass, getStatusDescriptionKey } from "./PriceGapReport.helpers";
import "./PriceGapReport.scss";

type Props = {
    className?: string;
};

/**
 * "What's this?" for the Price Gap statuses: every status in its report colour with what it means, in the
 * API's classification precedence, followed by how the tolerance is computed. Shared by the create form and
 * the report view.
 */
export const PriceGapStatusHelp = (props: Props) => {
    const intl = useIntl();

    return (
        <WhatsThis className={"PriceGapReport " + (props.className || "")}>
            <p>{intl.formatMessage({ id: "price_gap_statuses_intro" })}</p>
            <ul className={"list-unstyled"}>
                {Object.values(PriceGapStatusEnum).map((status) => (
                    <li key={status} className={"mb-2"}>
                        <span className={getStatusClass(status)}>{status}</span>
                        <span className={"ms-2"}>{intl.formatMessage({ id: getStatusDescriptionKey(status) })}</span>
                    </li>
                ))}
            </ul>
            <p className={"mb-0"}>{intl.formatMessage({ id: "price_gap_tolerance_help" })}</p>
        </WhatsThis>
    );
};
